// Hook odpowiedzialny za pobranie listy użytkowników do akceptacji zamówień

import axios from 'api/axios';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest,
  IUserRoles
} from 'api/types';

export interface IUserForOrderApprovalListItem {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role: IUserRoles;
}

export type IRequest = IPaginationRequest & ISearchRequest & {
  exclude_user_id?: number;
};
type IResponse = IPaginationResponse<IUserForOrderApprovalListItem>;

const getUsersForOrderApproval = (params?: IRequest): Promise<IResponse> => 
  axios.get('/users/for-order-approval', { params });

export const useGetUsersForOrderApproval = (params?: IRequest, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['users-for-order-approval', params], () => getUsersForOrderApproval(params), options);
